import BaseServiceTaal from "../../Service/BaseServiceTaal";
import TipologiaDocumento from "./TipologiaDocumento.repo";

export default class TipologiaDocumentoService extends BaseServiceTaal {
  getRepo = () => TipologiaDocumento.getInstanceTaal();
  getAllNewApi = () => this.getRepo().then((repo) => repo.getAllRegister());
}
